var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 40,
    viewBox: "0 0 136 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17495_79679)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.5914 6.49539L61.9785 33.5766H55.1901L60.8053 6.49539H67.5914ZM96.1483 23.9811L99.7214 13.8127L101.778 23.9811H96.1483ZM103.722 33.5766H110L104.52 6.49539H98.7266C97.4234 6.49539 96.3248 7.27689 95.8371 8.48146L85.6525 33.5766H92.7781L94.1941 29.5306H102.902L103.722 33.5766ZM86.0054 24.734C86.0358 17.5873 76.4302 17.1927 76.4963 13.9993C76.5173 13.0283 77.4133 11.9959 79.3753 11.7314C80.3463 11.6006 83.0285 11.499 86.0669 12.9428L87.2596 7.20055C85.6251 6.58843 83.5247 6 80.909 6C74.2007 6 69.478 9.68153 69.4403 14.9513C69.3956 18.852 72.8104 21.0255 75.3833 22.3224C78.0266 23.6494 78.9133 24.5008 78.9035 25.6877C78.8837 27.5055 76.7942 28.3067 74.8408 28.338C71.4283 28.393 69.4477 27.3859 67.8696 26.6269L66.6407 32.5614C68.225 33.3128 71.1526 33.9679 74.1887 34C81.3197 34 85.9833 30.3658 86.0054 24.734ZM57.8924 6.49539L46.895 33.5766H39.7204L34.3086 11.9639C33.98 10.6333 33.6949 10.1448 32.6959 9.58527C31.0645 8.67051 28.3703 7.81315 26 7.28051L26.1598 6.49539H37.7102C39.1814 6.49539 40.5059 7.50568 40.84 9.25614L43.6983 24.9275L50.7629 6.49539H57.8924Z",
    fill: "url(#paint0_linear_17495_79679)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17495_79679",
    x1: 26,
    y1: 34,
    x2: 110,
    y2: 34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B5098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#386EC1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17495_79679"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 136,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.adda880664e1a24c4ca8e813f695f88c.svg";
export { ForwardRef as ReactComponent };